export function openedTruckCheckNotice(
  checkType: "daily" | "monthly",
  apparatusName: string,
  statusLabel: string
): string {
  const label = checkType === "daily" ? "daily truck check" : "monthly truck check";
  return `Opened ${label} for ${apparatusName} (${statusLabel}). The kit list below now reflects this selected check.`;
}
